import { render, staticRenderFns } from "./SnowRegistration.vue?vue&type=template&id=0813e036&scoped=true&"
import script from "./SnowRegistration.vue?vue&type=script&lang=js&"
export * from "./SnowRegistration.vue?vue&type=script&lang=js&"
import style0 from "./SnowRegistration.vue?vue&type=style&index=0&id=0813e036&prod&scoped=true&lang=css&"
import style1 from "./SnowRegistration.vue?vue&type=style&index=1&id=0813e036&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0813e036",
  null
  
)

export default component.exports